import { useNavigate } from "react-router-dom";
import { STATUS, useRoom } from "../../lib/zhuyinRoom";
import { Grouped, RoomShell } from "../../components/zhuyin/RoomUI";

export default function ZhuyinProgress() {
  const nav = useNavigate();
  const { cards } = useRoom();
  const count = (s) => cards?.filter((z) => z.status === s).length || 0;
  return (
    <RoomShell title="我的注音進度" testid="zhuyin-progress-page">
      {cards && (
        <>
          <div className="grid grid-cols-2 sm:grid-cols-4 gap-3 mb-8" data-testid="progress-summary">
            {Object.entries(STATUS).map(([k, s]) => (
              <div key={k} className="rounded-3xl bg-white border-2 p-4 font-round" style={{ borderColor: `${s.color}66` }} data-testid={`progress-count-${k}`}>
                <div className="text-4xl font-black" style={{ color: s.color }}>{count(k)}</div>
                <div className="text-lg text-stone-600">{s.label}</div>
              </div>
            ))}
          </div>
          <Grouped cards={cards} render={(list, g) => (
            <div className="grid grid-cols-3 sm:grid-cols-5 lg:grid-cols-8 gap-3">
              {list.map((z) => (
                <button key={z.symbol} data-testid={`progress-item-${z.symbol}`} onClick={() => nav(`/zhuyin/s/${encodeURIComponent(z.symbol)}`)}
                  className="rounded-2xl bg-white border-4 p-3 flex flex-col items-center gap-1" style={{ borderColor: STATUS[z.status]?.color }}>
                  <span className="text-5xl font-black" style={{ color: g.color }}>{z.symbol}</span>
                  <span className="text-sm font-bold font-round" style={{ color: STATUS[z.status]?.color }}>{STATUS[z.status]?.label}</span>
                  <span className="text-xs text-stone-500 font-round">{z.attempts ? `練 ${z.attempts} 次・${Math.round((z.accuracy || 0) * 100)}%` : "—"}{z.traced ? "・寫過" : ""}</span>
                </button>
              ))}
            </div>
          )} />
        </>
      )}
    </RoomShell>
  );
}
